var _defs, _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g4, _path12, _path13, _path14, _g5, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabletImgChicaCompleta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 265,
    height: 581,
    viewBox: "0 0 265 581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 581,
    transform: "translate(745 785)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-745 -785)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-403.693 533.443)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1197.261,932.61a166.382,166.382,0,0,0-1.139,36.7c.732,9.051,2.736,19.02,9.1,23.968,4.636,3.608,10.523,3.671,16.05,3.616l33.967-.343c8.137-.082,17.231-.638,22.828-7.724,5.4-6.842,5.581-17.316,5.438-26.739-.225-14.822-.374-29.65-.675-44.47-.182-8.94-.994-16.588-5.007-24.24-9.384-17.893-24.091-37.411-43.936-32.8a19.6,19.6,0,0,0-2.057.595c-8.113,2.849-16.664,16.364-20.888,25.288a156.628,156.628,0,0,0-9.6,26.217A166.585,166.585,0,0,0,1197.261,932.61Z",
    transform: "translate(-6.926 -140.264)",
    fill: "#bbb8a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1338.2,932.61a166.382,166.382,0,0,0-1.138,36.7c.732,9.051,2.735,19.02,9.1,23.968,4.636,3.608,10.523,3.671,16.05,3.616l33.967-.343c8.137-.082,17.232-.638,22.828-7.724,5.4-6.842,5.581-17.316,5.438-26.739-.225-14.822-.374-29.65-.675-44.47-.182-8.94-.994-16.588-5.007-24.24-9.384-17.893-24.091-37.411-43.935-32.8a19.6,19.6,0,0,0-2.057.595c-8.113,2.849-16.664,16.364-20.888,25.288a156.649,156.649,0,0,0-9.6,26.217A166.777,166.777,0,0,0,1338.2,932.61Z",
    transform: "translate(-40.358 -140.264)",
    fill: "#bbb8a8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1187.675 271.385)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1230.088,345.037c9.893-13.2,7.2-31.075,14.443-45.6,6.578-17.563,31.261-37.6,48.164-20.943,4.953,8.26-6.321,15.106-10.231,21.4-21.522,37.592,31.36,62.067,53.875,83.5,27.168,35.669-63.129,45.709-85.155,47.783-34.861,5.931-68.559-11.753-52.981-51.076C1202,368.325,1229.475,351.369,1230.088,345.037Z",
    transform: "translate(-1194.292 -272.259)",
    fill: "#efde31"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1214.122 422.882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1272.41,471.219c-3.951-1.309-8.369,1.418-12.4,1.864-5.348,1.912-9.038,4.848-13.267,10.729-8.337,11.59-9.792,27.627-17.143,42.3-4.719,9.421,18.245,10.18,24.794,2.686,7.969-12.387,9.368-29.106,15.138-42.93C1270.072,481.326,1275.1,475.275,1272.41,471.219Z",
    transform: "translate(-1228.963 -470.867)",
    fill: "#20201d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1225.949 454.524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.686,571.872a2.512,2.512,0,0,1-.264-.587c-.145-.4-.391-.972-.627-1.738a31.47,31.47,0,0,1-1.229-6.684,44.551,44.551,0,0,1,4.462-21.791c.944-1.977,2-3.86,3.066-5.612,1.046-1.77,2.046-3.481,2.944-5.139a54.292,54.292,0,0,0,3.986-9.154c.894-2.709,1.54-4.933,2.011-6.462l.549-1.754a.324.324,0,1,1,.114.033l-.441,1.789c-.4,1.549-.985,3.79-1.831,6.529a51.974,51.974,0,0,1-3.9,9.288c-.89,1.678-1.883,3.4-2.924,5.176-1.068,1.771-2.093,3.609-3.03,5.568a45.627,45.627,0,0,0-4.581,21.511,35.029,35.029,0,0,0,1.028,6.646A22.441,22.441,0,0,1,1246.686,571.872Z",
    transform: "translate(-1244.468 -512.349)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1225.535 412.801)",
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1390.287,484.632c8.434,9.529,6.657,17.338,8,28.375a358.33,358.33,0,0,1,2.225,59.481c-11.5-.236-23.163.214-34.551-.671-3.053,5.832-10.074,3.073-13.1-1.439-5.363-6.473-15.846-11.269-16.119-20.512a6.286,6.286,0,0,0-.14-5.048c-7.388-8.729-20.646-14.209-31.972-11.731-12.24,2.921-20.564,15.079-32.735,18.276-9.009,2.367-19.717-.263-26.985,5.564-.526-9.2-1.786-18.46-.249-27.625,3.5-21.379-.294-51.033,19.2-59.731,12.738-5.683,34.818-3.96,44.376,5.822,17.038,17.439,17.011-27.651,42.322-15.694C1366.284,465.372,1378.732,472.552,1390.287,484.632Z",
    transform: "translate(-1243.925 -457.652)",
    fill: "#20201d"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.549,451.37c1.1,16.873-2.635,36.018-1.533,52.891",
    transform: "translate(-45.404 -43.361)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1303.861,468.9s-8.734,21.666-16.908,36.041",
    transform: "translate(-28.596 -47.519)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1239.147 287.192)",
    style: {
      isolation: "isolate"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.325,406.84c-6.079-.328-10.906-3.588-15.982-6.455-5.53-3.382-11.665-11.383-15.127-16.934-8.66-14.489-4.947-25.324-2.681-41.645,1.3-9.351,6.783-16.908,12.154-24.3a165.664,165.664,0,0,1,15.217-17.666c2.214-2.231,4.552-5.083,7.52-6.337,2-.846,4.053-.521,6.11-.075,16.127,3.5,32.416,6.071,48.669,8.9.111,10.157-.166,20.94-.252,31.121.226,14.415-1.211,28.993-.188,43.364.33,2.717-.459,4.433-2.163,6.568C1338.927,399.247,1318.569,407.881,1298.325,406.84Z",
    transform: "translate(-1261.769 -292.982)",
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1325.428,354.132c2.752-6.3,12.191-10.18,20.83,0",
    transform: "translate(-37.723 -18.81)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.22,358.364c0-4.719,12.275-13.394,19.6-2",
    transform: "translate(-26.999 -19.491)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1315.335,379.82a6.843,6.843,0,1,1-13.685,0c0-3.779,4.407-7.391,7.489-8.351",
    transform: "translate(-32.083 -24.408)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1298.618,403.721s6.893,14.7,29.927,0",
    transform: "translate(-31.363 -32.058)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1269.076 268.572)",
    style: {
      isolation: "isolate"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1304.613,276.118c5.594-8.125,14.151-7.277,22.593-7.546,23.705.767,43.668,17.9,51.048,39.961a120.924,120.924,0,0,1,5.73,13.776c3.98,8.735,2.239,20.868,10.545,26.982,9.33,6.138,18.544,11.3,25.868,20.048,13.674,15.071,16.624,41.8-2.028,54-11.59,11.3-22.495,11.116-39.626,8.584-8.734-1.291-15.254-3.61-22.171-9.041-10.967-7.569-15.013-28.353-6.125-38.632,14.984-26.327,8.5-52.973-15.425-70.978-5.477-4.7-11.166-9.162-16.359-14.182-3.737-2.86-5.87-7.913-9.961-10.047-2.191-.327-6.029,2.115-7.517.038A18.054,18.054,0,0,1,1304.613,276.118Z",
    transform: "translate(-1301.006 -268.572)",
    fill: "#efde31"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1277.057 398.468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1311.657,456.805c-.048-2.656-.735-6.308.853-8.4,1.323-1.744,6.179-1.667,8.961-1.69a36.763,36.763,0,0,0,13.861-3.035,43.8,43.8,0,0,0,4.838-2.37c.782-.445,1.526-.95,2.3-1.407a5.494,5.494,0,0,1,.921-.4c.353-.133.954-.676,1.246-.64a14.23,14.23,0,0,1,.243,3l.2,3.134c.464,7.118,2.394,13.263-2.161,18.969-2.787,3.493-3.945,7.9-6.9,11.287-3.2,3.672-8.4,6.047-13.03,4.519-3.761-1.242-6.342-4.719-8.038-8.3a34.306,34.306,0,0,1-3.228-12.91C1311.7,458.007,1311.669,457.414,1311.657,456.805Z",
    transform: "translate(-1311.468 -438.862)",
    fill: "#fff"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1238.574,686.9c9.349-21.053-.246-64.839,1.962-59.076-7.035-18.364.17-12.276-2.357-29.3-4.184-26.615,27.814-39.384,49.874-37.348,6.206.5,11.57,3.007,17.618,4.22,9.719,1.948,17.694,4.879,23.479,13.036,4.689,5.638-.944,1.1,3.423,6.868,5.635,7.449,12.861,27.909,10.436,36.134-1.452,3.832-.791,7.541.973,11.095,3.112,15.447,4.89,11.94,2.712,27.644,12.85,40.938,19.647,74.994,35.257,115,2.874,7.362,13.152,39.362,13.884,47.631,1.088,16.487-3.736,44.075-24.556,43.289-40.91-1.545-82.062-5.82-122.962-3.073-26.522,1.782-63.591-4.919-55.977-31.162C1209.443,772.9,1220.036,747.148,1238.574,686.9Z",
    transform: "translate(-5.914 -69.356)",
    fill: "#fff",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1215.5,572.8c1.51,6.231,12.4,14.622,16.379,7.113,3.433-8.494,17.225-12.873,16.466-23.1-2.557-4.824-20.4-11.089-20.4-11.089s-2.825,7.24-5.714,12.8C1220.875,563.409,1214.729,567.947,1215.5,572.8Z",
    transform: "translate(-11.631 -65.743)",
    fill: "#fff",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1241.713,567.486c-2.184-3.137,2.911-4.965,4.826-6.623,7.018-6.079,10.99-14.755,15.9-22.65,6.791-10.919,9.886-27.242,12.256-28.415,10.418-5.156,50.425-4.211,58.448,4.09,2.016,2.085,5.052,21.14,8.584,32.2,4.671,14.623,19.3,32.548,10.262,47.293-29.419,15.472-24.19-14.543-51.114-23.278-15.633-5.072-32.474-8.736-48.538-5.536C1251.516,568.26,1244.339,570,1241.713,567.486Z",
    transform: "translate(-17.739 -56.466)",
    fill: "#fff"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1166.397 487.469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1227.886,583.121,1213.67,556.9a2.592,2.592,0,0,0-2.279-1.356h-42.37a2.592,2.592,0,0,0-2.294,1.384l-.031.06a2.589,2.589,0,0,0,.073,2.543l37.087,61.663a2.593,2.593,0,0,0,1.926,1.239l39.112,4.488a2.592,2.592,0,0,0,2.587-1.365h0a2.592,2.592,0,0,0,.036-2.351Z",
    transform: "translate(-1166.397 -555.539)",
    fill: "#a39f8d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.345 2.732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1226.551,586.7,1211.9,559.667a1.044,1.044,0,0,0-.918-.546h-43.084a1.043,1.043,0,0,0-.912,1.55l35.914,64.687a1.042,1.042,0,0,0,.862.535L1245,627.882a1.044,1.044,0,0,0,.988-1.5Z",
    transform: "translate(-1166.849 -559.121)",
    fill: "#bbb8a8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.712 11.206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1200.96,574.3a2.283,2.283,0,0,0,3.21-.354l0,0a2.284,2.284,0,0,0-.355-3.21h0a2.283,2.283,0,0,0-3.21.353h0A2.288,2.288,0,0,0,1200.96,574.3Z",
    transform: "translate(-1200.105 -570.23)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1257.977,579.705c-3.87-3.148-7.176-7.433-12.514-8.049-3.233-.823-7.964.679-7.7,4.6,1.23,4.719,10.414,7.725,14.035,11.494,1.339.968,4.221,2.992,4.531,4.632.044.233-5.861-.5-6.5-.506-10.228,2.333-8.695-8.726-16.044-8.96-2.911.452-3.94,4.114-3.962,7.059-.693,15.484,9.819,27.163,24.531,30.657,26.929,8.762,53.748,18.206,80.669,26.891,10.786,3.085,21.543,6.084,32.414,8.5a21.623,21.623,0,0,0,25.388-12.813c6.731-13.474,1.825-30.407,2.446-44.74-13.616.51-27.427.252-40.981,1.227.627,4.629.493,19.33.317,21.406-.226,2.7-3,2.18-5.1,2.13-11.514-.171-63.335-9.818-68.324-18.886-4.261-6.887-7.456-14.613-13.219-20.455C1265.074,581.578,1261.136,581.49,1257.977,579.705Z",
    transform: "translate(-1181.435 -559.31)",
    fill: "#fff",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.071 13.492)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1203.793,619.548c2.971-4.693-4.409-5.69-7.539-6.767l-.115-.2c3.224,1.081,7.763-.359,5.119-4.316-2.658-2.027-6.368-2.4-9.65-3.5l0,0c3.254,1.224,11.182,1.893,7.927-3.712-3.539-2.428-8.234-2.924-12.524-4.218l-13.685-23.609c-8.22,3.218,3.215,18.528,7.315,23.051a5.6,5.6,0,0,0,1.895,5.475s-3.369.839-1.263,6.527a6.4,6.4,0,0,0,4,8.421c-1.909,9.648,13.305,8.648,16.424,5.471l-1.089-1.88A3.894,3.894,0,0,0,1203.793,619.548Z",
    transform: "translate(-1170.423 -573.226)",
    fill: "#fff",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.08,520.709",
    transform: "translate(-45.468 -59.808)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.09,451.37",
    transform: "translate(-45.945 -43.361)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1286.953,516.148",
    transform: "translate(-28.596 -58.726)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1308.9,476.166",
    transform: "translate(-33.802 -49.242)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.134,691.019s-14.807,6.8-99.365,0",
    transform: "translate(-21.674 -100.207)",
    fill: "#fff",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletImgChicaCompleta);
export default __webpack_public_path__ + "static/media/tablet_img_chica_completa.c593d9cebcf8df72570f935425ad5892.svg";
export { ForwardRef as ReactComponent };